$("#tabla_catalogos").DataTable({
    dom: '<"d-flex justify-content-between"lB><"col-md-6 p-0 my-3 float-end"f>rtip',
    buttons: [
        'excel', 'pdf'
    ],
    language: {
        url: url_base+'/vendor/datatables/spanish.json'
    },
});
$("#tabla-catalogo-elementos").DataTable({
    dom: '<"d-flex justify-content-between"lB><"col-md-6 p-0 my-3 float-end"f>rtip',
    "columnDefs": [
        { "type": "num", "targets": 0 }
    ],
    buttons: [
        'excel', 'pdf'
    ],
    language: {
        url: url_base+'/vendor/datatables/spanish.json'
    },
});

eliminarCatalogo = function(e){
    var data = e.dataset;
    $("#form_eliminar_catalogo")[0].reset();
    $("#eliminar_catalogo_id").val(data.id);
    $("#eliminar_catalogo_nombre").html(`¿Deseas eliminar el catálogo <strong>${data.nombre}</strong>?`);
}
agregarElemento = function(e){
    let tituloModal = $("#modalAgregarElementoTitulo");
    tituloModal.html('Agregar elemento');
    var data = e.dataset;
    $("#form_agregar_elemento")[0].reset();
    $("#elemento_catalogo_id").val(data.catalogoid);
    if(data.id)
        tituloModal.html('Editar elemento');
    $("#elemento_id").val(data.id);
    $("#nombre_elemento").val(data.nombre);
    $("#codigo_elemento").val(data.codigo);
    $("#padre_elemento_id").val(data.padreid);
}
eliminarElemento = function(e){
    var data = e.dataset;
    $("#form_eliminar_elemento")[0].reset();
    $("#eliminar_elemento_id").val(data.id);
    $("#eliminar_elemento_nombre").html(`¿Deseas eliminar el elemento <strong>${data.nombre}</strong>?`);
}
